import React, { PropsWithChildren } from 'react'
import Footer from '../components/Footer'
import './style.css'; 
import HeaderPrivate from '../components/HeaderPrivate';

const PrivateLayout: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="">
        <HeaderPrivate />
        <div className=''>
            {children}
        </div>
        <Footer />
    </div>
    
    )
}

export default PrivateLayout
